import Component from "~/route-containers/partner/partner.container";
import { MetaFunction } from "@remix-run/node";
import { homeLoader } from "~/loaders/home.loader";
import { ShouldRevalidateFunction } from "@remix-run/react";
import { getUrlCanonical } from "@commons-monorepo/index";

export const meta: MetaFunction = ({ matches }) => {
  const parentsData = matches[0]?.data;
  const storeMetadata = parentsData?.storeMetadata;
  const description = storeMetadata?.description;
  const formattedDescription =
    description && description.length > 160
      ? description.slice(0, 160) + "..."
      : description;
  const canonical = getUrlCanonical(parentsData);
  const partnerProfilePicture =
    storeMetadata?.profilePicConfiguration?.squareImage;

  const facebookMetadata = storeMetadata?.configuration?.facebookMetadata;
  const googleShoppingVerificationTag =
    storeMetadata?.configuration?.googleMetadata;
  const facebookMetaContent = facebookMetadata?.match(/content=["“](.*)["”]/i);
  const googleShoppingVerificationTagContent =
    googleShoppingVerificationTag?.match(/content=["“](.*)["”]/i);
  const resultMatchFacebook = facebookMetaContent && facebookMetaContent[1];
  const resultMatchGoogleShoppingVerificationTag =
    googleShoppingVerificationTagContent &&
    googleShoppingVerificationTagContent[1];

  return [
    { title: storeMetadata?.enterpriseName || "Catálogo de productos" },
    { name: "description", content: formattedDescription },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=1",
    },
    {
      name: "og:title",
      content: storeMetadata?.enterpriseName || "Catálogo de productos",
    },
    { name: "og:image", content: partnerProfilePicture },
    { name: "og:description", content: description },
    { name: "facebook-domain-verification", content: resultMatchFacebook },
    {
      name: "google-site-verification",
      content: resultMatchGoogleShoppingVerificationTag,
    },
    { tagName: "link", rel: "canonical", href: canonical },
  ];
};

export const shouldRevalidate: ShouldRevalidateFunction = ({
  currentParams,
  currentUrl,
  defaultShouldRevalidate,
  nextParams,
  nextUrl,
}) => {
  if (
    currentParams.partnerId === nextParams.partnerId &&
    currentUrl.searchParams.toString() === nextUrl.searchParams.toString()
  ) {
    return false;
  }

  return defaultShouldRevalidate;
};

export { homeLoader as loader };

export default Component;
